import React from 'react';
import { AttributeKey } from './characterTypes';
import AttributeSelector from './AttributeSelector';
import {
  AttributesContainer,
  AttributeGroupContainer,
  GroupTitle,
} from './CharacterStyles';
import { ATTRIBUTE_GROUPS, ATTRIBUTE_OPTIONS_MAP } from './characterConstants';
import { transformKeyToTitle } from './charactersUtils';
import { useCharacter } from './CharacterContext';

// Create a type for the attribute keys available in ATTRIBUTE_OPTIONS_MAP
type AvailableAttributeKey = keyof typeof ATTRIBUTE_OPTIONS_MAP;

interface CharacterAttributesProps {
  onAttributeChange: (key: AttributeKey, value: string | string[]) => void;
  onRandomizeAttribute: (attributeKey: AttributeKey) => void;
  currentStep?: number;
}

const CharacterAttributes: React.FC<CharacterAttributesProps> = ({
  onAttributeChange,
  onRandomizeAttribute,
  currentStep = 0,
}) => {
  const { character } = useCharacter();
  // Get only the current attribute group based on currentStep
  const currentGroup = ATTRIBUTE_GROUPS[currentStep];

  return (
    <AttributesContainer>
      <AttributeGroupContainer key={currentGroup.id}>
        <GroupTitle>{currentGroup.label}</GroupTitle>

        {currentGroup.attributes.map((attributeKey) => {
          // Only process attribute keys that exist in our options map
          if (attributeKey in ATTRIBUTE_OPTIONS_MAP) {
            const key = attributeKey as AvailableAttributeKey;
            const options = ATTRIBUTE_OPTIONS_MAP[key];
            const isMultiSelect = key === 'clothing';
            const title = transformKeyToTitle(key);
            const allowCustomInput = key !== 'age';

            return (
              <AttributeSelector
                key={key}
                attributeKey={key as AttributeKey}
                title={title}
                options={options}
                selectedValue={character[key]}
                onChange={(value) =>
                  onAttributeChange(key as AttributeKey, value)
                }
                multiSelect={isMultiSelect}
                onRandomize={onRandomizeAttribute}
                allowCustomInput={allowCustomInput}
              />
            );
          }
          return null;
        })}
      </AttributeGroupContainer>
    </AttributesContainer>
  );
};

export default CharacterAttributes;
